import { get } from 'lodash-es';
import type { Recordable } from '@mts-fe/types';
import type { RouteLocationNormalized, RouteRecordNormalized } from 'vue-router';
import { RequestMethod } from '.';

export function getRawRoute(route: RouteLocationNormalized): RouteLocationNormalized {
  if (!route) return route;
  const { matched, ...opt } = route;
  return {
    ...opt,
    matched: (matched
      ? matched.map((item) => ({
          meta: item.meta,
          name: item.name,
          path: item.path,
        }))
      : undefined) as RouteRecordNormalized[],
  };
}

/** 匹配替换url中的变量 */
const URL_PARAM_REGEX = /\{((?![/}]).)+\}/g;
export const replaceUrl = (url: string, params: Recordable) => {
  if (!url.includes('{')) return url;
  // if (!Object.keys(params).length) return url;

  const matches = url.matchAll(URL_PARAM_REGEX);

  let res = '';
  let lastIndex = 0;

  for (const item of matches) {
    // Add content before match
    if (item.index !== undefined && item.index > lastIndex) {
      res += url.substring(lastIndex, item.index);
    }

    // Extract and replace parameter
    const matchedStr = item[0];
    const key = matchedStr.substring(1, matchedStr.length - 1);
    const value = get(params, key);

    res += value ?? '';

    if (item.index !== undefined) {
      lastIndex = item.index + matchedStr.length;
    }
  }

  if (lastIndex < url.length) {
    res += url.substring(lastIndex);
  }

  return res;
};

type RouterMethod = 'push' | 'replace' | 'go';
/** 解析路由上指定的方法 */
export const parseRouteMethod = (path: string): [string, RouterMethod] => {
  if (!path.includes('@')) return [path, 'push'];
  const [method, _path] = path.split('@');
  return [_path, method as RouterMethod];
};

/** 解析api路径上指定的方法 */
export const parseRequestMethod = (api: string) => {
  const method = Object.values(RequestMethod).find((i) => api.includes(i));
  return [method ? api.replace(method, '') : api, method] as const;
};

/** 从浏览器记录中获取指定路径的完整路径 */
export const getPathFromHistory = (path: string) => {
  if (!history.state.back) return path;
  return history.state.back.includes(path + '?') ? history.state.back : path;
};

/**
 * Add the object as a parameter to the URL
 * @param baseUrl url
 * @param obj
 * @returns {string}
 * eg:
 *  let obj = {a: '3', b: '4', c: ['1','2']}
 *  setObjToUrlParams('www.baidu.com', obj)
 *  ==>www.baidu.com?a=3&b=4&c=1,2
 */
export function setObjToUrlParams(baseUrl: string, obj: any): string {
  let parameters = '';
  for (const key in obj) {
    const value = obj[key];
    if (Array.isArray(value)) {
      parameters += `${key}=${encodeURIComponent(value.join(','))}&`;
    } else {
      parameters += `${key}=${encodeURIComponent(value)}&`;
    }
  }
  parameters = parameters.replace(/&$/, '');
  return /\?$/.test(baseUrl) ? baseUrl + parameters : baseUrl.replace(/\/?$/, '?') + parameters;
}
